export default {
  back: 'Back to Menu',
  menu: 'Menu',
};
